<script setup>
import { computed } from "vue";
import Section from "../internal/Section.vue";
import ServiceCard from "../fields/ServiceCard.vue";

const props = defineProps({
  data: { type: Object, required: true },
  editMode: { type: Boolean, default: false },
  isOwn: { type: Boolean, default: false },
});

const emit = defineEmits(["toggle-service"]);

// Note: точные коды требуют подтверждения у бэкенда (см. spec, открытый вопрос #2).
const SERVICE_CARDS = [
  {
    code: "SOVER_EXECUT_NADPIS",
    icon: "huge-edit",
    title: "Исполнительная надпись",
    sub: "Совершение исполнительной надписи",
  },
];

const codes = computed(() => props.data.notarial_actions_codes || []);

function isOn(code) {
  return codes.value.includes(code);
}

function onToggle(code, value) {
  emit("toggle-service", code, value);
}
</script>

<template>
  <Section
    icon="sli-services"
    :title="$t('Услуги')"
    :sub="$t('Виды нотариальных действий, доступных нотариусу')"
  >
    <div class="grid grid-cols-2 gap-3 max-md:grid-cols-1">
      <ServiceCard
        v-for="card in SERVICE_CARDS"
        :key="card.code"
        :icon="card.icon"
        :title="$t(card.title)"
        :sub="$t(card.sub)"
        :model-value="isOn(card.code)"
        :disabled="!editMode"
        @update:model-value="onToggle(card.code, $event)"
      />
    </div>
  </Section>
</template>
